module.exports = __webpack_public_path__ + "img/1192490453.16e2e870.jpg";